import { UntypedFormControl } from '@angular/forms';
import { SuperModel, FieldConfig } from './super-model';
import { WeightageModel } from './weightage-model';

export class SkillsSelectionModel extends SuperModel {
    isReadonly: boolean;
    isHidden: boolean;
    fieldType: FieldType;
    fieldColumn: string;
    isRequired: boolean;
    additionalMetaData: MetadataBuilder = {};
    options: skillDataOptions;
    value?: Array<Value>;
    constructor(field) {
        super(field);
        this.additionalMetaData = field.additionalMetaData;
        if ([null, undefined].includes(this.additionalMetaData)) {
            this.additionalMetaData = {};
        }
        if (!this.additionalMetaData.hasOwnProperty('showLabel')) {
            this.additionalMetaData.showLabel = true;
        }
        if (!this.additionalMetaData.hasOwnProperty('selectionType')) {
            this.additionalMetaData.selectionType = 'weightage';
        }
    }
}

type FieldType = 'skillsSelectionField';

export interface skillDataOptions {
    caption: string,
    data: [
        {
            key: string | number,
            value: string,
            childData: {
                caption: string,
                data: [
                    {
                        key: string | number,
                        value: string,
                        skillLevel?: number,
                        percentage?: number,
                        control?: UntypedFormControl,
                        field?: WeightageModel,
                        selected?: boolean
                    }
                ]
            },
            selected?: boolean
        }
    ]
}
interface MetadataBuilder {
    showLabel?: boolean;
    changeEventEmit?: boolean;
    maxWeightage?: number | Array<{
        key: any;
        value: string;
        weightage?: number;
        description?: string;
    }>;
    defaultWeightage?: number;
    minWeightage?: number;
    expectedWeightage?: number;
    showHelp?: boolean;
    removable?: boolean;
    selectionType?: 'weightage' | 'standard';
}
interface Value {
    key: string | number,
    value?: string,
    skillLevel: number
}

